import { render, staticRenderFns } from "./pagea.vue?vue&type=template&id=cc83c116&scoped=true"
import script from "./pagea.vue?vue&type=script&lang=js"
export * from "./pagea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc83c116",
  null
  
)

export default component.exports